import { render, staticRenderFns } from "./CmgViewMoreRestaurants.vue?vue&type=template&id=75dee665&scoped=true&lang=pug"
import script from "./cmg-view-more-restaurants.ts?vue&type=script&lang=ts&external"
export * from "./cmg-view-more-restaurants.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgViewMoreRestaurants.vue?vue&type=style&index=0&id=75dee665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dee665",
  null
  
)

export default component.exports